import styles from "./average-item.module.css";

export interface AverageItemProps {
  color: string;
  value: number;
  label: string;
}

function AverageItem(props: AverageItemProps) {
  const { color, value, label } = props;

  const render = () => (
    <div style={{ border: `3px solid ${color}` }} className={styles["item"]}>
      <div className={styles["label"]}>{label}</div>
      <div style={{ color: color }} className={styles["value"]}>
        {value > 0 ? value.toFixed(1) : 0}
      </div>
    </div>
  );

  return render();
}

export default AverageItem;
